import { useContext, useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { useDispatch } from "react-redux";
import { getAgentWiseMemberAction, getAllMemberAction, getAllMemberAtOnceAction } from "../../../Redux/Action/MemberAction";
import Auth from "../../../Utilities/Auth";
import Parse from "../../../Utilities/parse";
import CommonPagination from "../../CommonComponent/CommonPagination/CommonPagination";
import { MemberContext } from "../AllMemberComponent";
import MemberTableConfig from "../Utilities/MemberTableConfig";
import TableTwoBody from '../../CommonComponent/BootstrapTable2Body/TableTwoBody';

function MemberTable({ data = [] }) {
    //Context
    const {
        setMemberIdCardModelShow,
        setIdData,
        searchedKey,
        allMemberReload, donationModelShow,
        setAllMemberReload,
        setFilteredMemberData,
        setEditMemberModelShow,
        setGetSingleMemberData,
        setDonationModelShow,
        currentPage,
        setCurrentPage,
        member_barcode,
        agent_id,
        setDataForTable
    } = useContext(MemberContext)

    const dispatch = useDispatch()


    const [pageConfigurationFromCommonPagination, setPageConfigurationFromCommonPagination] = useState({})
    const user_detail = JSON.parse(Auth.header().userdetail)

    // data get lifecycle
    useEffect(() => {
        memberFetch()
    }, [currentPage, allMemberReload, donationModelShow, pageConfigurationFromCommonPagination]);

    // data fetch
    // const memberFetch = () => {
    //     const Payload = {
    //         data: {
    //             search_key: searchedKey,
    //             skip: (currentPage - 1) * 10,
    //             limit: 10,
    //             agent_id: agent_id,
    //             member_barcode
    //         },
    //         setDataForTable,
    //         pageConfigurationFromCommonPagination
    //     }
    //     if (donationModelShow == false && Object.keys(pageConfigurationFromCommonPagination).length != 0) {
    //         let permission = JSON.parse(Auth.header().userdetail || "{}")
    //         permission.is_admin ? dispatch(getAllMemberAction(Payload)) : dispatch(getAgentWiseMemberAction(Payload))
    //     }
    // }

    const memberFetch = () => {
        const Payload = {
            data: {
                agent_id: agent_id,
            },
            setDataForTable,
            pageConfigurationFromCommonPagination
        }
        if (donationModelShow == false) {
            let permission = JSON.parse(Auth.header().userdetail || "{}")
            // permission.is_admin ? dispatch(getAllMemberAction(Payload)) : dispatch(getAgentWiseMemberAction(Payload))
            dispatch(getAllMemberAtOnceAction(Payload))
        }
    }

    // column and column initial
    const columns = MemberTableConfig.allColumn({
        setMemberIdCardModelShow,
        setIdData,
        currentPage,
        setDonationModelShow,
        setEditMemberModelShow,
        setGetSingleMemberData
    });

    if (!user_detail?.is_admin == "1") {
        columns.splice(8, 1)
    }

    return (
        <>
            {/* <BootstrapTable
                wrapperClasses={'table-responsive'}
                headerClasses={"tableTwoHeader"}
                keyField="id"
                data={dataForTable.data || []}
                columns={columns}
            />
            <CommonPagination
                setPageConfigurationFromCommonPagination={setPageConfigurationFromCommonPagination}
                totalPage={Math.ceil((Parse.toNumber(dataForTable.totalRowCount) / 10) || 0)}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            /> */}

            <TableTwoBody
                is_pagination={false}
                products={data || []}
                columns={columns}
                isBorderd={true}
            />
        </>
    );
}

export default MemberTable;